import React from "react";
import {PublisherDataPointCard} from "../Card/publisherDataPointCard"
import {IPublisherDiscOverview} from "../../../interfaces/DataPointDtoMainPage.interface";
import {Grid} from "@leap4/frontend";


export interface IPublisherDataPointCardsProps {
    dataPoints: IPublisherDiscOverview[]
}

export const PublisherDataPointCards = (props: IPublisherDataPointCardsProps): JSX.Element => {
    return <Grid container gap={"15px"} >
        {
            props.dataPoints.map(dataPoint => {

                return (
                    <Grid item key={dataPoint.dataPoint._id.toString()}>
                    <PublisherDataPointCard dataPointOverview={dataPoint}/>
                    </Grid>
                )
                }
            )
        }

    </Grid>

}